import React,{useEffect} from 'react'
import login from "./assets/images/loginCover.svg";
import NoInternet from "./assets/images/no_internet.jpg";
import AccountLogin from './AccountLogin/accountLogin';
import Otp from './Otp/otp';
import Register from './Register/Register';
import {connect} from 'react-redux';
import * as actions from "../../store/actions/action"; 
import { withRouter } from 'react-router';
import ReduxToastr from "react-redux-toastr";
import "./index.css";
import { Trans, useTranslation } from "react-i18next";
function Login(props) {
  const { t, i18n } = useTranslation();
  const statusRedirect = [
        "AccountLogin",
        "Otp",
        "Register",
        "AlreadyLoggedIn"
    ];
    useEffect(()=>{
        props.getFreeTestAction();
        let studentData={isWebApp:true}
        localStorage.setItem("studentData",JSON.stringify(studentData));
    },[])

    useEffect(()=>{
        if (props.verifyOtp && props.verifyOtp.user && props.verifyOtp.user.exists && props.verifyOtp.user.signedUp) {
            handleLoginSuccess(props.verifyOtp);
        }
        else if (
            props.registerUser && props.registerUser.user &&
            !props.registerUserError
        ) {
            handleLoginSuccess(props.registerUser);
        }

    },[props.registerUser,props.verifyOtp]);

   const  handleLoginSuccess = loginDetail => {
        var data = {
            refreshToken: loginDetail.refreshToken,
            token: loginDetail.token,
            tokenExpiryTime: loginDetail.tokenExpiryTime,
            studentId: loginDetail.studentId,
            parents: loginDetail.parents,
            user: loginDetail.user,
            organization: { id: loginDetail.orgId }
        };
        if (loginDetail.user.type == 2) {
            data.parentId = loginDetail.parentId;
            data.children = loginDetail.children;
        }
        let loginData = { orgCode: props.orgCode}
        if (props.mobile) {
            loginData.mobile = props.mobile
        } 
        window.localStorage.setItem("loginData", JSON.stringify(loginData));
        window.localStorage.setItem("data", JSON.stringify(data));
    };
  const  handleGenerateOtp = (retry) => {
        let reqObj = {
            countryExt: props.CountryCode,
            orgCode:props.orgCode,
            viaSms: props.email ? "0" : "1",
            viaEmail: props.email ? "1" : "0",
            retry: retry ? retry : 0,
            orgId: props.orgId
        };
        Object.assign(
            reqObj,
             props.loginState == 0
            ? { mobile: props.mobile }
            : { email: props.email }
        );
        props.generateOtpAction(reqObj);
    };

    return (
        <div className="login-container">
            { <div className="no-internet-card"><div><img src={NoInternet} alt=""/></div>
                <div className="no-internet-text"><Trans i18nKey="Routes.Login.indexjs.NoInternetText">Please check your internet and try again.</Trans></div> </div>}
            <div className="login-left">
                <div className="login-left-content">
                    <p className="login-left-heading">
                        {t("Routes.Login.indexjs.LoginLeftHeading","The future of education is here")}
                    </p>
                    <p className="login-left-subheading">
                        <Trans i18nKey="Routes.Login.indexjs.LoginLeftSubheading">With an all in one platform for the teaching world</Trans>
                    </p>
                    <img src={login} alt="" className="login-left-image" />
                </div>
            </div>
            <div className="login-right">
                {(()=>{
                    switch(props.statusRedirection){
                        case statusRedirect[0]:
                            return(
                                <AccountLogin 
                                name={props.name}
                                mobile={props.mobile}
                                setMobileAction={props.setMobileAction}
                                handleGenerateOtp={handleGenerateOtp}
                                testName={props.testName}
                                orgName={props.orgName}
                                loginState={props.loginState}
                                email={props.email}
                                setEmailAction={props.setEmailAction}
                                CountryCode={props.CountryCode}
                                mobileRegex={props.mobileRegex}
                                />
                            );
                        case statusRedirect[1]:
                            return(
                                 <Otp
                                 setStatusAction={props.setStatusAction}
                                 mobile={props.mobile}
                                 orgCode={props.orgCode}
                                 orgId={props.orgId}
                                 handleGenerateOtp={handleGenerateOtp}
                                 verifyOtpErrorChangeAction={props.verifyOtpErrorChangeAction}
                                 verifyOtpError={props.verifyOtpError}
                                 setOtpAction={props.setOtpAction}
                                 generateOtp={props.generateOtp}
                                 verifyOtpAction={props.verifyOtpAction}
                                 loginState={props.loginState}
                                 email={props.email}
                                 CountryCode={props.CountryCode}
                                 />
                            );
                         case statusRedirect[2]:
                                return(
                                     <Register
                                     setMobileAction={props.setMobileAction}
                                     setStatusAction={props.setStatusAction}
                                     name={props.name}
                                     mobile={props.mobile}
                                     orgCode={props.orgCode}
                                     orgId={props.orgId}
                                     generateOtp={props.generateOtp}
                                     otp={props.otp}
                                     saveUserInfoType={props.saveUserInfoType}
                                     registerUserAction={props.registerUserAction}
                                     loginState={props.loginState}
                                     email={props.email}
                                     CountryCode={props.CountryCode}
                                     mobileRegex={props.mobileRegex}
                                     />
                                );
                          case statusRedirect[3]:   
                          return(
                              props.history.push(`/attempt/?testId=${props.testId}`)
                          )        
                    }
                })()}
           
            </div>
        </div>
    )
}





function mapStateToProps(state) {
    return {
        orgCode: state.loginReducer && state.loginReducer.orgCode,
        orgId: state.loginReducer && state.loginReducer.orgId,
        orgName:state.loginReducer && state.loginReducer.orgName,
        testName: state.loginReducer && state.loginReducer.testName,
        mobile: state.loginReducer && state.loginReducer.mobile,
        email: state.loginReducer && state.loginReducer.email,
        countryCode: state.loginReducer && state.loginReducer.countryCode,
        otp: state.loginReducer && state.loginReducer.otp,
        role: state.loginReducer && state.loginReducer.role,
        name: state.loginReducer && state.loginReducer.name,
        statusRedirection:
            state.loginReducer && state.loginReducer.statusRedirection,
        verifyOtpError: state.loginReducer && state.loginReducer.verifyOtpError,
        generateOtp:
        (state.loginReducer && state.loginReducer.generateOtp) || {},
        name: state.loginReducer && state.loginReducer.name,
        otp: state.loginReducer && state.loginReducer.otp,
        registerUser:
            (state.loginReducer && state.loginReducer.registerUser) || {},
        verifyOtp: (state.loginReducer && state.loginReducer.verifyOtp) || {},
        testId : state.loginReducer && state.loginReducer.testId || '',
        loginState: state.loginReducer.loginType,
        CountryCode:state.loginReducer.countryISO,
        mobileRegex:state.loginReducer.mobileRegex || null,
        saveUserInfoType:state.loginReducer.saveUserInfoType,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMobileAction: data => dispatch(actions.setMobileAction(data)),
        setEmailAction: data => dispatch(actions.setEmailAction(data)),
        generateOtpAction: data => dispatch(actions.generateOtpAction(data)),
        setStatusAction: data => dispatch(actions.setStatusAction(data)),
        verifyOtpErrorChangeAction: data => dispatch(actions.verifyOtpErrorChangeAction(data)),
        setOtpAction: data => dispatch(actions.setOtpAction(data)),
        verifyOtpAction: data => dispatch(actions.verifyOtpAction(data)),
        registerUserAction: data => dispatch(actions.registerUserAction(data)),
        getFreeTestAction:data=>dispatch(actions.getFreeTestAction(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
